document.addEventListener("DOMContentLoaded", function() {
  // Select metafield container
  const metafieldContainer = document.querySelector(".custom-metafield-varaint");
  // Select Shopify variant wrapper
  const variantWrapper = document.querySelector(".product-block .variant-wrapper.js:nth-child(2)");

  // Safety check
  if (!variantWrapper) return;

  // Function to check metafield content
  function updateVariantVisibility() {
    if (metafieldContainer) {
      const hasImage = metafieldContainer.querySelectorAll("img").length > 0;
      if (hasImage) {
        variantWrapper.style.display = "none";
      } else {
        variantWrapper.style.display = "block";
      }
    } else {
      variantWrapper.style.display = "block";
    }
  }

  // Run on page load
  updateVariantVisibility();

  // In case metafield loads later (AJAX themes)
  let tries = 0;
  const interval = setInterval(() => {
    updateVariantVisibility();
    tries++;
    if (tries > 20) clearInterval(interval); // stop after ~2 seconds
  }, 100);
});

/* ── Plain / Model Toggle ── */
function initModelToggle() {
  const container = document.getElementById("collection-model-toggle");
  if (!container) return;

  const options = container.querySelectorAll(".collection-model-toggle__option");
  
  options.forEach(function(option) {
    option.addEventListener("click", function() {
      const view = this.getAttribute("data-view"); // 'plain' or 'model'
      const isModel = view === "model";
      
      // Update active states
      options.forEach(opt => opt.classList.remove("collection-model-toggle__option--active"));
      this.classList.add("collection-model-toggle__option--active");
      container.setAttribute("data-state", view);
      
      // swap images on every product card
      document.querySelectorAll(".grid__item-image-wrapper[data-plain-src]").forEach(function (wrapper) {
        const plainSrc = wrapper.getAttribute("data-plain-src");
        const modelSrc = wrapper.getAttribute("data-model-src");
        if (!modelSrc) return;

        const img = wrapper.querySelector("img");
        if (!img) return;

        if (isModel) {
          // backup src and srcset before overwriting
          if (!img.hasAttribute("data-plain-src-backup")) {
            img.setAttribute("data-plain-src-backup", img.currentSrc || img.src || "");
            img.setAttribute("data-plain-srcset-backup", img.srcset || "");
          }
          img.srcset = "";
          img.src = modelSrc;
        } else {
          // restore original src + srcset
          const srcBackup = img.getAttribute("data-plain-src-backup") || plainSrc;
          const srcsetBackup = img.getAttribute("data-plain-srcset-backup") || "";
          img.src = srcBackup;
          img.srcset = srcsetBackup;
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", initModelToggle);
document.addEventListener("shopify:section:load", initModelToggle);
